/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

import {Maximum} from '../kernel_names';
import {GradConfig} from '../kernel_registry';
import {cast} from '../ops/array_ops';
import {greaterEqual} from '../ops/greater_equal';
import {less} from '../ops/less';
import {mul} from '../ops/mul';
import {Tensor} from '../tensor';

export const maximumGradConfig: GradConfig = {
  kernelName: Maximum,
  inputsToSave: ['a', 'b'],
  gradFunc: (dy: Tensor, saved: Tensor[]) => {
    const [a, b] = saved;
    const derA = () => mul(dy, cast(greaterEqual(a, b), 'float32'));
    const derB = () => mul(dy, cast(less(a, b), 'float32'));
    return {a: derA, b: derB};
  }
};
